import React from "react";
import { HashRouter, Route, Routes, Navigate } from "react-router-dom";

import { routes } from "@liro_u/cms-front";
import customRoutes from "../src/utils/routes.js";

import { useAuthContext } from "@liro_u/react-auth-components";

// pages
import { PopUp, EditorSwitch, PageView, Error404 } from "@liro_u/cms-front";
import { Login, Signup } from "@liro_u/react-auth-components";

function App() {
  const { user, ready } = useAuthContext();

  return (
    <div className="App">
      <PopUp />
      {ready && (
        <HashRouter>
          <Routes>
            {/* AUTH */}
            <Route
              exact
              path={routes.login}
              element={user ? <Navigate to={routes.home} /> : <Login />}
            />
            <Route
              exact
              path={routes.signup}
              element={user ? <Navigate to={routes.home} /> : <Signup />}
            />

            {/*Editor*/}
            <Route
              exact
              path={routes.editor + "/:id"}
              element={user ? <EditorSwitch /> : <Navigate to={routes.login} />}
            />
            <Route exact path={routes.editor} element={<EditorSwitch />} />

            {/*Page*/}
            <Route exact path={routes.page + "/:id"} element={<PageView />} />
            <Route exact path={routes.page} element={<PageView />} />

            {/*Project*/}
            <Route
              exact
              path={customRoutes.gameProject}
              element={<PageView pageId="6490914ee7a1d4b1eb1d557c" />}
            />
            <Route
              exact
              path={customRoutes.jamProject}
              element={<PageView pageId="649091fde7a1d4b1eb1d5586" />}
            />
            <Route
              exact
              path={customRoutes.webProject}
              element={<PageView pageId="6490920be7a1d4b1eb1d5589" />}
            />
            <Route
              exact
              path={customRoutes.allProject}
              element={<PageView pageId="6490921ce7a1d4b1eb1d558c" />}
            />

            {/*Resume*/}
            <Route
              exact
              path={customRoutes.resume}
              element={<PageView pageId="64ca0a46759bb5f82a17e262" />}
            />

            {/*Home*/}
            <Route
              exact
              path={routes.home}
              element={<PageView pageId="6490314131d069505d20438d" />}
            />

            {/*Admin*/}
            <Route
              exact
              path={routes.admin}
              element={<PageView pageId="64d3bc3b16e1c86b7e48fecb" />}
            />

            {/* Error 404 */}
            <Route path="*" element={<Error404 />} />
          </Routes>
        </HashRouter>
      )}
    </div>
  );
}

export default App;
